<template>
	<div class="vue-offer-shortcode">
		<div class="row m-b-20">
			<div class="col">
				<div class="create-offer-title">
					Compose Offer
				</div>
			</div>
			<div class="col" >
				<div class="text-right">
					<button class="btn btn-secondary" :class="{ 'is-loading' : modal.is_loading}" @click.stop.prevent="showModal">Select a Template</button>
				</div>
			</div>
		</div>
		<transition name="fade" mode="out-in">
			<div class="pd-30" v-if="is_change" key="is-change">
				<div class="spinner-border text-primary" role="status">
					<span class="sr-only">Loading...</span>
				</div>
			</div>
			<div v-else key="change-success">
				<div class="list-shortcode-items" >
					<div v-for="(item, index) in form " class="shortcode-item" :class="{'shortcode-item-heading' : item.heading}" :key="`short${index}`">
						<template v-if="item.heading">
							<div class="shortcode-field" >
								<shortcode :currency="currency"   :disabled="!item.show" :invalid="errors[index].$invalid && formstate" :is-general="isGeneral" v-model="item.shortcodes" ></shortcode>
							</div>
							<div class="shortcode-action">
								<button class="btn  btn-icon btn-icon-ban" @click="item.show = !item.show" :class="item.show ? 'btn-secondary' : 'btn-outline-success'">
									<i class="far fa-ban"></i>
								</button>
							</div>
						</template>
						<template v-else>
							<div class="shortcode-icon">
								<icon-picker :allow-clear="true" :on-select="icon => onSelectIcon(icon , index)"  >
									<template slot="icon" >
										<button class="btn btn-secondary btn-icon">
											<img v-if="item.icon" :src="`${icon_path}/${item.icon}`" alt="">
										</button>
									</template>
								</icon-picker>
							</div>
							<div class="shortcode-field">
								<shortcode  :currency="currency"  :invalid="errors[index].$invalid && formstate" :is-general="isGeneral" v-model="item.shortcodes" ></shortcode>
							</div>
							<div class="shortcode-action">
								<button class="btn btn-secondary btn-icon" @click="removeRow(index)" :disabled="form.length < 3">
									<i class="far fa-trash-alt"></i>
								</button>
							</div>
						</template>
						
					</div>
				</div>
				<div class="text-left" v-if="form.length < 11">
					<button class="btn btn-secondary" @click="addRow">
						+ Add
					</button>
				</div>
			</div>
		</transition>
		<vue-modal class="modal-messages" width="900px" v-model="modal.show" @on-hide="onHideModal">
			<template slot="modal-header">
				<div class="modal-header-container">
					<h5>Select template</h5>
				</div>
			</template>
			<template slot="modal-body">
				<simplebar class="modal-body-container">
					<div class="list-item-message">
						<div class="row" >
							<div class="col col-6 m-b-30" v-for="(item, index) in modal.data" :key="`index_item_${index}`">
								<div class="item-message"  @click.stop.prevent="onSelect(item)" :class="{ 'is-active' : modal.selected && modal.selected.id == item.id}">
									<offer-preview :theme="defaultData.theme_setting"  :message="item.data" ></offer-preview>
								</div>
							</div>
						</div>
					</div>
				</simplebar>
			</template>
			<template slot="modal-footer">
				<div class="modal-footer-container">
					<button class="btn btn-secondary" @click="modal.show = false">Cancel</button>
					<button class="btn btn-primary" @click="onSave()" :disabled="modal.selected == null">Apply</button>
				</div>
			</template>
		</vue-modal>
	</div>
</template>
<script>
import Shortcode from '@/components/vue-shortcode'
import IconPicker from '@/components/vue-iconpicker'
import { mapGetters, mapActions } from 'vuex';
import VueModal from '@/components/vue-modal'
import OfferPreview from './offer-preview'
export default {
	name : 'OfferShortcode',
	components:{
		Shortcode,
		IconPicker,
		VueModal,
		OfferPreview
	},
	props:{
		value :{
			type : Array,
			required : true,
		},
		isGeneral : {
			type : Boolean,
			default : true,
		},
		formstate :{
			type : Boolean,
			required : true,
		},
		validate:{
			type : Object,
			required : true,
		},
		content :{
			type : Object,
		},
	},
	data(){
		return {
			default_row : {
				"icon" : "img1/1.png",
				"heading": false,
				"show": true,
				"shortcodes": {
					"value" : "",
					"options" : [],
					"validate" : true
				},
			},
			is_saving : false,
			is_change: false,
			modal :{
				is_loading : false,
				selected : null ,
				data: [],
				show : false,
			}
		}
	},
	computed:{
		...mapGetters({
			icon_path : 'auth/getIconPath',
			defaultData : 'offer/getDefaultData'
		}),
		form :{
			get(){
				return this.value 
			},
			set(value){
				this.$emit('input', value)
			}
		},
		currency(){
			return this.content && this.content.currency ? this.content.currency : 'USD'
		},
		errors(){
			return Object.values(this.validate.$each.$iter)
		}
	},
	methods:{
		...mapActions({
			get : 'setting/getSample'
		}),
		onSelectIcon(icon,index){
			this.form[index].icon = icon ? icon.path : null
		},
		addRow(){
			if( this.form.length == 11) return
			this.form.push(JSON.parse(JSON.stringify(this.default_row)))
		},
		removeRow(index){
			if( this.form.length < 2) return
			this.form.splice(index,1)
		},
		onHideModal(){
			this.modal = {
				is_loading : false,
				selected : null ,
				data: [],
				show : false,
			}
		},
		showModal(){
			if( this.modal.is_loading ) return 
			this.modal.is_loading = true 
			this.get({type : 'message'}).then((res)=>{
				let { status , data = null } = res.data 
				if( status  && data ){
					this.modal.data = data.map((item)=>{
						item['data'] = this.$helper.convertToShortcode(item.data)
						return item
					})
					this.modal.show = true
				}else{
					this.$toast({
						title: "Warning !",
						message: 'No message template found',
						icon: "fad fa-exclamation-circle",
						type: 'danger',
						time : 2000,
					});
				}
			})
			.finally(()=>{
				this.modal.is_loading = false 
			})
		},
		onSelect(item){
			var item = this.$clone(item)
			if( this.modal.selected ){
				if( this.modal.selected.id == item.id ){
					this.modal.selected = null 
				}else{
					this.modal.selected = item 
				}
			}else{
				this.modal.selected = item 
			}
		},
		onSave(){
			this.$confirm.show({
				title : 'Are you sure?',
				content : 'Do you want to replace your current editing with the selected template?',
				contentType : 'text',
				btnClose : 'Cancel',
				btnCloseClass : 'btn btn-secondary',
				onClose : null ,
				btnSave : 'Replace',
				btnSaveClass : 'btn btn-primary',
  				onSave:  ()=>{
  					return new Promise( (resolve, reject)=>{
						this.is_change = true 
						this.$nextTick(()=>{
							this.form = this.$clone(this.modal.selected.data)
							this.modal.show = false
							this.is_change = false 
						})
						
  						resolve();
  					});
  				}
			})
		}
	},
}
</script>
<style lang="scss" scoped>
	.vue-offer-shortcode{
		.list-shortcode-items{
			.shortcode{
				&-item{
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					margin-bottom: 15px;
					&.shortcode-item-heading{
						.shortcode-field{
							@include flex(calc(100% - 32px));
							padding-left: 0;
						}
					}
				}
				&-icon{
					@include flex(32px);
				}
				&-action{
					@include flex(32px);
					text-align: right;
				}
				&-field{
					@include flex(calc(100% - 64px));
					padding: 0 10px;
				}
			}
		}
	}
	.modal-messages{
		.modal{
			&-header-container{
				padding: 15px;
				border-bottom: 1px solid #f2f2f2;
			}
			&-body-container{
				padding: 15px;
				height: 450px;
				overflow: hidden auto;
				.list-item-message{
					
					.item-message{
						cursor: pointer;
						position: relative;
						border-radius: 5px;
						padding: 0px;
						border: 4px solid transparent;
						background: #F8F8F8;
						box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
						&:last-child{
							margin-bottom: 0;
						}
						&:hover ,&.is-active{
							border-color: $primary;
						}
					}
				}
			}
			&-footer-container{
				border-top: 1px solid #f2f2f2;
				padding: 6px 15px;
				text-align: right;
			}
		}
	}
</style>